import React from 'react'
import styled from 'styled-components'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import {
  borderRadiusSizes,
  marginSizes,
  padding,
  paddingSizes
} from '@jarvis.oddle/core/theme/default'
import OrderSummaryDropdown from 'src/components/molecules/OrderSummaryDropdown'
import Card from '@jarvis.oddle/core/components/Card'

const StyledCard = styled(Card).attrs(() => ({
  borderRadius: borderRadiusSizes.small,
  marginBottom: marginSizes.medium
}))`
  width: 100%;
  padding: ${padding[paddingSizes.medium]};
  ${breakpoint('desktop')`
    display: none;
  `}
`

const OrderSummaryMobile = ({
  orderTotal,
  OrderSummary
}: {
  orderTotal: string
  OrderSummary: JSX.Element
}): JSX.Element => (
  <StyledCard>
    {OrderSummary && (
      <OrderSummaryDropdown
        orderTotal={orderTotal}
        OrderSummary={OrderSummary}
      />
    )}
  </StyledCard>
)

export default OrderSummaryMobile
